module.exports = __webpack_public_path__ + "img/session2_card_icon4.64fef5da.png";